import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifzero_rgbled',
  message0: '%{BKY_CUSTOM_MACHINE_IFZERO_RGBLED}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/kByzBzq/ifkit.jpg',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'input_value',
      name: 'COLOR',
      check: 'Color'
    },
    {
      type: 'input_value',
      name: 'LED_ID',
      check: 'Number'
    }
  ],
  inputsInline: true,
  previousStatement: null,
  nextStatement: null,
  style: 'led_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_RGBLED_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifzero_rgbled'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifzero_rgbled'] = function (block) {
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifzero = 'import ifzero'
  let color = Blockly.Python.valueToCode(
    block,
    'COLOR',
    Blockly.Python.ORDER_ATOMIC
  )
  let ledId = Blockly.Python.valueToCode(
    block,
    'LED_ID',
    Blockly.Python.ORDER_ATOMIC
  )
  ledId = ledId ? ledId : 0
  let code = `ifzero.led3Color(${ledId}, ${color})\n`
  return code
}
